export default __webpack_public_path__ + "static/media/em-icons.a1c42c90.svg";